import Vue from 'vue';
import Vuex from 'vuex';
import locale from './locale';
import notify from './notify';
import loading from './loading';
import authenticate from './authenticate';
import dbTable from './dbTable';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    locale, notify, loading, authenticate, dbTable,
  },
});
